<template>
    <div class="widget widget-product card" v-if="promoSectionProduct != '' && promoSectionProduct[sectionNumber] != null">
        <header class="card-header">
            <h3 class="card-title">
                <span>{{   promoSectionProduct[sectionNumber].Title  }}</span>
            </h3>
           
        </header>
        <div class="product-carousel owl-carousel owl-theme">
            <div style="position:relative" class="item  discount-box" v-for="(product,index) in promoSectionProduct[sectionNumber].PromProducts">
                <div :class="!product.IsAvailable ? 'filter' : '' ">
                    <router-link :title="product.Name"
                                 :to="getProductLink(product)">
                        <img :src="product.PicPath"
                             class="img-fluid"
                             :alt="product.AltPicPath"
                             :title="product.Name"
                             @error="imageLoadOnError">
                    </router-link>

                    <h2 class="post-title">
                        <router-link :title="product.Name"
                                     :to="getProductLink(product)">
                            {{ product.Name }}
                        </router-link>
                    </h2>


                    <div>
                        <div class="price">
                            <div v-if="!product.IsAvailable">
                                <span class="unAvailable">ناموجود</span>
                            </div>
                        </div>

                        <!--<div class="wi-div-in" v-if="product.IsAvailable">
                            <i @click="AddItemWithProductId(product.Id)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                        </div>-->
                    </div>


                </div>
            </div>

        </div>
    </div>
</template>

<script>    
    import { setCart } from "../../module/cart";
    export default {
  
        props: ["sectionNumber"],
        computed: {
            promoSectionProduct() {
                return this.$store.getters.readPromoSectionProducts;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            } 
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            getProductLink(product) {
                const baseName =
                    product.RedirectLink && product.RedirectLink.trim() !== ''
                        ? product.RedirectLink
                        : product.Name;

                const cleanedName = baseName
                    .replace(/\//g, '-')
                    .replace(/\*/g, '-')
                    .replace(/\s+/g, '-');

                return {
                    name: 'product',
                    params: {
                        productId: product.Id,
                        productName: cleanedName
                    }
                };
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            AddItemWithProductId(productId) {
                setCart(this, productId, 'AddItemWithProductId', '.loader', null, 1);
            },
        }

    }
</script>

<style scoped>
    .call {
        font-size: 13px;
    }
    .unAvailable {
        font-size: 14px;
    }
        .discount-box {
            position: relative;
        }

.discount-box .discount {
    content: '';
    width: 55px;
    height: 35px;
    background-color: #ef5662;
    color: #fff;
    top: 20px;
    left: 15px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border-radius: 40px;
    z-index: 9999;
    font-size: 16px;
}
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }
        .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }
        .widget-product .product-carousel .item ins, .brand-slider .product-carousel .item ins {
            color: #ef5661;
            font-size: 13px;
        }
    }
    @media only screen and (min-width: 641px) and (max-width: 640px) {
        .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }
    }
</style>